import ProductCard from "./ProductCard";

/**
 * Responsive product strip:
 *  - Mobile (default): horizontal-scrolling, snap-aligned row showing ~1.6
 *    cards at a time so the user always sees there's more to browse.
 *  - Tablet (sm): 3-up grid.
 *  - Desktop (lg+): 4-up grid (5-up for very wide screens via xl breakpoint
 *    when products.length >= 5).
 *
 * Used by Home → Crowd Favourites and Featured Pickles/Spices/Masalas to
 * reduce excessive vertical scrolling on mobile while showing more products
 * per screen, matching the laptop visual composition more closely.
 */
export default function ProductStrip({ products, testId, columnsLg = 4 }) {
  if (!products || products.length === 0) return null;
  const lgCols = columnsLg === 5 ? "lg:grid-cols-5" : "lg:grid-cols-4";
  return (
    <>
      {/* Mobile carousel (sm-) */}
      <div
        className="sm:hidden -mx-4 px-4 flex gap-3 overflow-x-auto snap-x snap-mandatory scroll-pl-4 pb-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        data-testid={testId ? `${testId}-mobile-strip` : undefined}
      >
        {products.map((p, i) => (
          <div
            key={p.product_id}
            className="snap-start shrink-0 w-[62vw] max-w-[260px]"
          >
            <ProductCard p={p} index={i} />
          </div>
        ))}
      </div>
      {/* Tablet/desktop grid (sm+) */}
      <div
        className={`hidden sm:grid sm:grid-cols-3 ${lgCols} gap-5 lg:gap-6`}
        data-testid={testId ? `${testId}-grid` : undefined}
      >
        {products.map((p, i) => (
          <ProductCard key={p.product_id} p={p} index={i} />
        ))}
      </div>
    </>
  );
}
